import { apiInstance } from 'api/utils';
// TODO: remove test1 from url
export default {
  getMetaTimeHorizon: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/time-horizons/'
    });
  },
  getMetaRiskLevel: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/risk-levels/'
    });
  },
  getMetaAssetClass: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/asset-classes/'
    });
  },
  getMetaKnowledgeLevel: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/knowledge-levels/'
    });
  },
  getMetaPolicyProvider: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/policy-providers/'
    });
  },
  getMetaPolicyType: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/policy-types/'
    });
  },
  getMetaPlatformChargeApplicationTypes: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/platform-charge-application-types/'
    });
  },
  getMetaPolicyTypeForRecommended: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/policy-types/?cip=1'
    });
  },
  getMetaPolicyPlatform: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/policy-platforms/'
    });
  },
  getMetaPolicyChargeType: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/policy-charge-types/'
    });
  },
  getMetaRiskAssetAllocation: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/risk-asset-allocations/'
    });
  },
  getMetaReturnForecasts: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/return-forecasts/'
    });
  },
  getMetaReturnForecastsConfig: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/return-forecasts-config/'
    });
  },
  getMorningstarReturnForecastsConfig: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/morningstar-return-forecasts-config/'
    });
  },
  getMetaReturnForecastTypes: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/return-forecast-types/'
    });
  },
  getMetaRiskCapacity: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/risk-capacity/'
    });
  },
  getRiskRequirementLevels: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/risk-requirement-levels/'
    });
  },
  getPolicyActionTypes: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/policy-action-types/'
    });
  },
  getContributionAccounts: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/contribution-accounts/'
    });
  },
  getContributionFrequencies: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/contribution-frequencies/'
    });
  },
  getContributionSources: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/contribution-sources/'
    });
  },
  getAdvisorChargesTypes: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/advisor-charges-types/'
    });
  },
  getAdvisorChargesAccounts: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/advisor-charges-accounts/'
    });
  },
  getRiskDescriptions: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/risk-levels-descriptions/'
    });
  },
  getAssetClasses: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/asset-classes-new/'
    });
  },
  getModelPortfolios: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/config/model-portfolio-choices/?cip=1'
    });
  },
  getChargeSources: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/source-values/'
    });
  },
  getCapacityForLossQuestions: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/capacity-for-loss-questions/'
    });
  },
  getCapacityForLossToggles: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/capacity-for-loss-toggles/'
    });
  },
  getExperienceQuestions: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/experience-questions/'
    });
  }
};
